import { ORDER_EXPERIENCES } from '@ordersnproducts/modules/shared/constants/order-experiences';
import { SHIPPING_CONDITION_CODE } from '../../../../../../shared/constants/shipping-conditions-codes';
import { rmsUL } from './delivery/rms-ul.config';

export const readymix = {
  [SHIPPING_CONDITION_CODE.DELIVERY]: {
    [ORDER_EXPERIENCES.RMX_UNIVERSAL_LINK]: rmsUL,
  },
};

export interface IRMSCutoffConfig {
  firstBusinessDayPointer: number;
  secondBusinessDayPointer: number;
}

export const RMS_SAME_DAY_CONFIG: IRMSCutoffConfig = {
  firstBusinessDayPointer: 0,
  secondBusinessDayPointer: 1,
};

export const RMS_UK_CUTOFF_CONFIG: IRMSCutoffConfig = {
  firstBusinessDayPointer: 1,
  secondBusinessDayPointer: 2,
};
